import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { AccesPages } from './acces-pages';

/**
 * Après chaque route contrôlée par canMatch, propose un écran au même chemin.
 * Un refus ne charge ni le composant protégé, ni ses résolveurs, et conserve l’URL.
 */
export function avecEcranAccesRefuse(routes: Routes): Routes {
  return routes.flatMap((route) =>
    route.canMatch?.length
      ? [
          route,
          {
            path: route.path,
            pathMatch: 'full' as const,
            loadComponent: () =>
              import('../Pages/acces-refuse/acces-refuse').then((m) => m.AccesRefuse),
            title: 'Accès à la page',
            data: { hideSiloParc: true },
            resolve: { refusAcces: () => inject(AccesPages).refusCourant() },
          },
        ]
      : [route],
  );
}
